// import node module libraries
import { Col, Row, Card } from 'react-bootstrap';

const Version_00_00_04 = () => {
	return (
		<Row>
			<Col lg={12} md={12} sm={12}>
				<Card>
					<Card.Body>
						<Row className="g-0">
							<Col lg={3} md={4} sm={12}>
								<div id="initial">
									<h5 className="mb-3 fwsemi--bold">
										<code>v0.0.4</code> - XX Monat. 2025
									</h5>
								</div>
							</Col>
							<Col lg={9} md={8} sm={12}>
								<div>
									<h4 className="mb-1 fw-semi-bold">Basisfunktionen erweitert</h4>
									<ul>
										<li>
											Thema 1
										</li>
										<li>
											Thema 2
										</li>
									</ul>
									<div className="mb-3">
										<h4>Thema 1:</h4>
										<ul>
											<li>
												Neu - Neues Feature
												<br />
											</li>
											<li>
												Update - Angepasstes Feature
												<br />
											</li>
										</ul>
									</div>
								</div>
							</Col>
						</Row>
					</Card.Body>
				</Card>
			</Col>
		</Row>
	);
};

export default Version_00_00_04;
